'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _TargetDateSeries = require('./TargetDateSeries.css');

var _TargetDateSeries2 = _interopRequireDefault(_TargetDateSeries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iyvConfig = {
  fff: {
    id: 'fff',
    cats: [{
      lbl: 'Top 200 carbon reserve owners',
      cnt: 'c2_count',
      asst: 'c2_asset',
      wght: 'c2_weight',
      icon: require('../../../static/images/sectoricons/icn-is_c2.svg'),
      fld: 'is_c2'
    }, {
      lbl: 'Coal industry',
      cnt: 'co_count',
      asst: 'co_asset',
      wght: 'co_weight',
      icon: require('../../../static/images/sectoricons/icn-is_co.svg'),
      fld: 'is_co'
    }, {
      lbl: 'Oil/gas industry',
      cnt: 'og_count',
      asst: 'og_asset',
      wght: 'og_weight',
      icon: require('../../../static/images/sectoricons/icn-is_og.svg'),
      fld: 'is_og'
    }, {
      lbl: 'Top 30 coal-fired utilities',
      cnt: 'mc50_count',
      asst: 'mc50_asset',
      wght: 'mc50_weight',
      icon: require('../../../static/images/sectoricons/icn-is_mc50.svg'),
      fld: 'is_mc50'
    }, {
      lbl: 'Fossil-fired utilities',
      cnt: 'ut_count',
      asst: 'ut_asset',
      wght: 'ut_weight',
      icon: require('../../../static/images/sectoricons/icn-is_ut.svg'),
      fld: 'is_ut'
    }, {
      lbl: 'All fossil fuel screens',
      cnt: 'ff_all_count',
      asst: 'ff_all_asset',
      wght: 'ff_all_weight'
    }]
  },
  //
  ffb: {
    id: 'ffb',
    cats: [{
      lbl: 'Fossil fuel finance',
      cnt: 'fossil_bank_count',
      asst: 'fossil_bank_asset',
      wght: 'fossil_bank_weight',
      icon: require('../../../static/images/icons/ffb-icon.svg'),
      fld: 'is_fossil_bank'
    }]
  },
  //
  ffi: {
    id: 'ffi',
    cats: [{
      lbl: 'Fossil fuel insurance',
      cnt: 'fossil_insure_count',
      asst: 'fossil_insure_asset',
      wght: 'fossil_insure_weight',
      icon: require('../../../static/images/icons/ffi-icon.svg'),
      fld: 'is_fossil_insure'
    }]
  },
  //
  dff: {
    id: 'dff',
    cats: [{
      lbl: 'Deforestation-risk agribusiness',
      cnt: 'df_p_count',
      asst: 'df_p_asset',
      wght: 'df_p_weight',
      icon: require('../../../static/images/sectoricons/icn-is_df_p.svg'),
      fld: 'is_df_p'
    }, {
      lbl: 'Deforestation-risk finance',
      cnt: 'df_f_count',
      asst: 'df_f_asset',
      wght: 'df_f_weight',
      icon: require('../../../static/images/sectoricons/icn-is_df_f.svg'),
      fld: 'is_df_f'
    }, {
      lbl: 'Deforestation-risk consumer brands',
      cnt: 'df_c_count',
      asst: 'df_c_asset',
      wght: 'df_c_weight',
      icon: require('../../../static/images/sectoricons/icn-is_df_c.svg'),
      fld: 'is_df_c'
    }, {
      lbl: 'All deforestation-risk screens',
      cnt: 'df_all_count',
      asst: 'df_all_asset',
      wght: 'df_all_weight'
    }]
  },
  //
  gef: {
    id: 'gef'
  },
  //
  gff: {
    id: 'gff',
    cats: [{
      lbl: 'Gun manufacturers',
      cnt: 'wff_gun_manufacturers_count',
      asst: 'wff_gun_manufacturers_asset',
      wght: 'wff_gun_manufacturers_weight',
      icon: require('../../../static/images/sectoricons/icn-is_gm.svg'),
      fld: 'is_wff_gun_manufacturers'
    }, {
      lbl: 'Gun retailers',
      cnt: 'wff_gun_retailers_count',
      asst: 'wff_gun_retailers_asset',
      wght: 'wff_gun_retailers_weight',
      icon: require('../../../static/images/sectoricons/icn-is_gr.svg'),
      fld: 'is_wff_gun_retailers'
    }, {
      lbl: 'All civilian firearms screens',
      cnt: 'wff_civ_count',
      asst: 'wff_civ_asset',
      wght: 'wff_civ_weight'
    }]
  },
  //
  pff: {
    id: 'pff',
    cats: [{
      lbl: 'Private prison operators',
      cnt: 'pff_extreme_count',
      asst: 'pff_extreme_asset',
      wght: 'pff_extreme_weight',
      icon: require('../../../static/images/sectoricons/icn-is_pff_extreme.svg'),
      fld: 'is_pff_extreme'
    }, {
      lbl: 'Prison industrial complex, high-risk',
      cnt: 'pff_high_count',
      asst: 'pff_high_asset',
      wght: 'pff_high_weight',
      icon: require('../../../static/images/sectoricons/icn-is_pff_high.svg'),
      fld: 'is_pff_high'
    }, {
      lbl: 'Prison industry',
      cnt: 'pff_prisons_count',
      asst: 'pff_prisons_asset',
      wght: 'pff_prisons_weight',
      icon: require('../../../static/images/sectoricons/icn-is_prisons.svg'),
      fld: 'is_pff_prisons'
    }, {
      lbl: 'Border industry',
      cnt: 'pff_borders_count',
      asst: 'pff_borders_asset',
      wght: 'pff_borders_weight',
      icon: require('../../../static/images/sectoricons/icn-is_borders.svg'),
      fld: 'is_pff_borders'
    }, {
      lbl: 'All prison industrial complex screens',
      cnt: 'pff_all_count',
      asst: 'pff_all_asset',
      wght: 'pff_all_weight'
    }]
  },
  //
  wff: {
    id: 'wff',
    cats: [{
      lbl: 'Nuclear weapons',
      cnt: 'wff_nuclear_weapons_count',
      asst: 'wff_nuclear_weapons_asset',
      wght: 'wff_nuclear_weapons_weight',
      icon: require('../../../static/images/sectoricons/icn-is_nw.svg'),
      fld: 'is_wff_nuclear_weapons'
    }, {
      lbl: 'Controversial weapons',
      cnt: 'wff_cluster_munitions_count',
      asst: 'wff_cluster_munitions_asset',
      wght: 'wff_cluster_munitions_weight',
      icon: require('../../../static/images/sectoricons/icn-is_cm.svg'),
      fld: 'is_wff_cluster_munitions'
    }, {
      lbl: 'All military contractors',
      cnt: 'wff_major_military_contractors_count',
      asst: 'wff_major_military_contractors_asset',
      wght: 'wff_major_military_contractors_weight',
      icon: require('../../../static/images/sectoricons/icn-is_mmc.svg'),
      fld: 'is_wff_major_military_contractors'
    }]
  },
  //
  tff: {
    id: 'tff',
    cats: [{
      lbl: 'Tobacco producers',
      cnt: 't_count',
      asst: 't_asset',
      wght: 't_weight',
      icon: require('../../../static/images/sectoricons/icn-is_t.svg'),
      fld: 'is_t'
    }, {
      lbl: 'Tobacco-promoting entertainment studios',
      cnt: 't_m_count',
      asst: 't_m_asset',
      wght: 't_m_weight',
      icon: require('../../../static/images/sectoricons/icn-is_t_m.svg'),
      fld: 'is_t_m'
    }, {
      lbl: 'All tobacco screens',
      cnt: 't_all_count',
      asst: 't_all_asset',
      wght: 't_all_weight'
    }]
  }
};

var TargetDateSeries = (_dec = (0, _reactCssModules2.default)(_TargetDateSeries2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeries, _Component);

  function TargetDateSeries(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeries);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeries.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeries)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      strategyName: props.params.strategyName ? props.params.strategyName : '',
      showFundDetails: false,
      activeIssue: 'fossil', // config.app.title,
      pageDescription: 'See how target date funds popular in employee retirement plans are rated on environmental and social sustainability issues.'
    };
    return _this;
  }

  (0, _createClass3.default)(TargetDateSeries, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.scrollTop();
      this.setState({ activeIssue: this.initActiveIssue(this.props) });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      // if new target date fund
      if (props.params.strategyName !== this.state.strategyName) {
        this.scrollTop();
        this.setState({
          strategyName: props.params.strategyName || '',
          showFundDetails: false,
          activeIssue: this.initActiveIssue(this.props)
        });
      }
      // if new query issue
      if (props.location.query && props.location.query.issue && props.location.query.issue !== this.state.activeIssue) {
        this.scrollTop();
        this.setState({ activeIssue: this.initActiveIssue(props) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.params.strategyName) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main-grid' },
          _container2.default.helmet('Target date funds', this.state.pageDescription, _config2.default.app.domain + _config2.default.routes.targetDateFunds),
          _react2.default.createElement(_components.TargetDateGrid, { page: true })
        );
      }

      var targetDateSeries = this.configTargetDateSeries();
      if (!targetDateSeries) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main-grid' },
          _container2.default.helmet('Target date funds', this.state.pageDescription, _config2.default.app.domain + _config2.default.routes.targetDateFunds),
          _react2.default.createElement(_components.TargetDateGrid, { page: true })
        );
      }

      var icons = {
        fff: require('../../../static/images/icons/fff-icon.svg'),
        ffb: require('../../../static/images/icons/ffb-icon.svg'),
        ffi: require('../../../static/images/icons/ffi-icon.svg'),
        dff: require('../../../static/images/icons/dff-icon.svg'),
        gef: require('../../../static/images/icons/gef-icon.svg'),
        gff: require('../../../static/images/icons/gff-icon.svg'),
        pff: require('../../../static/images/icons/pff-icon.svg'),
        wff: require('../../../static/images/icons/wff-icon.svg'),
        tff: require('../../../static/images/icons/tff-icon.svg')
      };
      var iconsColor = {
        fff: require('../../../static/images/icons/fff-icon-white.svg'),
        ffb: require('../../../static/images/icons/ffb-icon-white.svg'),
        ffi: require('../../../static/images/icons/ffi-icon-white.svg'),
        dff: require('../../../static/images/icons/dff-icon-white.svg'),
        gef: require('../../../static/images/icons/gef-icon-white.svg'),
        gff: require('../../../static/images/icons/gff-icon-white.svg'),
        pff: require('../../../static/images/icons/pff-icon-white.svg'),
        wff: require('../../../static/images/icons/wff-icon-white.svg'),
        tff: require('../../../static/images/icons/tff-icon-white.svg')
      };

      // these will change based on which of 7 sites we're on
      var thisConfig = {};
      switch (this.state.activeIssue) {
        case 'fossil':
          thisConfig = iyvConfig.fff;
          break;

        case 'fossil-fuel-lending':
          thisConfig = iyvConfig.ffb;
          break;

        case 'fossil-fuel-insurance':
          thisConfig = iyvConfig.ffi;
          break;

        case 'deforestation':
          thisConfig = iyvConfig.dff;
          break;

        case 'gender-equality':
          thisConfig = iyvConfig.gef;
          break;

        case 'guns':
          thisConfig = iyvConfig.gff;
          break;

        case 'prison-industrial-complex':
          thisConfig = iyvConfig.pff;
          break;

        case 'military-weapons':
          thisConfig = iyvConfig.wff;
          break;

        case 'tobacco':
          thisConfig = iyvConfig.tff;
          break;
      }

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(targetDateSeries.strategy_name, 'See how ' + targetDateSeries.strategy_name + ' is rated on environmental and social sustainability issues.', _config2.default.domain + _config2.default.routes.targetDateFunds + '/' + this.state.strategyName),
        _react2.default.createElement(
          'div',
          { styleName: 'page-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(_components.TargetDateSeriesNameHeader, {
              targetDateSeries: targetDateSeries
            }),
            _react2.default.createElement(_components.PlanScorecardDefaultScorecard, { fund: targetDateSeries, notPlan: true }),
            _react2.default.createElement(
              'nav',
              { styleName: 'nav-flex' },
              ['fff', 'ffb', 'ffi', 'dff', 'gef', 'gff', 'pff', 'wff', 'tff'].map(function (e, i) {
                var sitename = {
                  fff: 'fossil',
                  ffb: 'fossil-fuel-lending',
                  ffi: 'fossil-fuel-insurance',
                  dff: 'deforestation',
                  gef: 'gender-equality',
                  gff: 'guns',
                  pff: 'prison-industrial-complex',
                  wff: 'military-weapons',
                  tff: 'tobacco'
                }[e];
                return _react2.default.createElement(
                  'button',
                  {
                    key: 'nav-item-' + i,
                    styleName: 'nav-item',
                    onClick: function onClick() {
                      if (_this2.state.activeIssue !== sitename) {
                        _this2.setState({ activeIssue: sitename });

                        _this2.context.router.push({
                          pathname: _config2.default.routes.targetDateFunds + '/' + _this2.state.strategyName,
                          query: {
                            issue: sitename
                          }
                        });
                      }
                    }
                  },
                  _react2.default.createElement('img', {
                    src: _this2.state.activeIssue === sitename ? iconsColor[e] : icons[e],
                    alt: sitename,
                    styleName: _this2.state.activeIssue === sitename ? 'nav-img-actv' : 'nav-img'
                  })
                );
              })
            ),
            _react2.default.createElement(_components.TargetDateSeriesGradeDescription, {
              iyvCode: thisConfig.id,
              targetDateSeries: targetDateSeries
            }),
            _react2.default.createElement(
              'div',
              null,
              this.state.activeIssue === 'fossil' ? _react2.default.createElement(_components.TargetDateSeriesDoughnutChart, {
                iyvCode: thisConfig.id,
                targetDateSeries: targetDateSeries
              }) : null,
              this.state.activeIssue === 'fossil-fuel-lending' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null)
              ) : null,
              this.state.activeIssue === 'fossil-fuel-insurance' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null)
              ) : null,
              this.state.activeIssue === 'deforestation' ? _react2.default.createElement(_components.TargetDateSeriesDoughnutChart, {
                iyvCode: thisConfig.id,
                targetDateSeries: targetDateSeries
              }) : null,
              this.state.activeIssue === 'gender-equality' ? _react2.default.createElement('div', null) : null,
              this.state.activeIssue === 'guns' ? _react2.default.createElement(_components.TargetDateSeriesDoughnutChart, {
                iyvCode: thisConfig.id,
                targetDateSeries: targetDateSeries
              }) : null,
              this.state.activeIssue === 'prison-industrial-complex' ? _react2.default.createElement(_components.TargetDateSeriesDoughnutChart, {
                iyvCode: thisConfig.id,
                targetDateSeries: targetDateSeries
              }) : null,
              this.state.activeIssue === 'military-weapons' ? _react2.default.createElement(_components.TargetDateSeriesDoughnutChart, {
                iyvCode: thisConfig.id,
                targetDateSeries: targetDateSeries
              }) : null,
              this.state.activeIssue === 'tobacco' ? _react2.default.createElement(_components.TargetDateSeriesDoughnutChart, {
                iyvCode: thisConfig.id,
                targetDateSeries: targetDateSeries
              }) : null,
              this.state.activeIssue !== 'gender-equality' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.TargetDateSeriesCategoriesTable, {
                  iyvConfigCategories: thisConfig.cats,
                  targetDateSeries: targetDateSeries
                }),
                _react2.default.createElement(_components.TargetDateSeriesHoldingsLists, {
                  iyvConfigCategories: thisConfig.cats,
                  targetDateSeries: targetDateSeries
                })
              ) : null
            ),
            _react2.default.createElement(_components.TargetDateSeriesMethodologyLink, {
              targetDateSeries: targetDateSeries,
              iyvCode: thisConfig.id,
              linkType: 'fullProfile'
            }),
            _react2.default.createElement(_components.TargetDateSeriesMethodologyLink, {
              targetDateSeries: targetDateSeries,
              iyvCode: thisConfig.id,
              linkType: 'methodology'
            }),
            _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: thisConfig.id }),
            _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: thisConfig.id }),
            _react2.default.createElement(_components.TargetDateSeriesFullScorecard, {
              targetDateSeries: targetDateSeries
            }),
            _react2.default.createElement(_components.TargetDateSeriesAllNamesTickers, {
              targetDateSeries: targetDateSeries
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return TargetDateSeries;
}(_react.Component), _class2.propTypes = {}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.scrollTop = function () {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  };

  this.initActiveIssue = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var issues = ['fossil', 'fossil-fuel-lending', 'fossil-fuel-insurance', 'deforestation', 'gender-equality', 'guns', 'prison-industrial-complex', 'military-weapons', 'tobacco'];
    // const sitenames = [
    //   'Fossil Free Funds',
    //   'Deforestation Free Funds',
    //   'Gender Equality Funds',
    //   'Guns Free Funds',
    //   'Prison Free Funds',
    //   'Weapon Free Funds',
    //   'Tobacco Free Funds'
    // ]
    var activeIssue = 'fossil';
    if (props && props.location && props.location.query && props.location.query.issue && issues.includes(props.location.query.issue)) {
      activeIssue = props.location.query.issue;
    }
    // else if (sitenames.includes(config.app.title)) {
    //   activeIssue = {
    //     'Fossil Free Funds': 'fossil',
    //     'Deforestation Free Funds': 'deforestation',
    //     'Gender Equality Funds': 'gender-equality',
    //     'Guns Free Funds': 'guns',
    //     'Prison Free Funds': 'prison-industrial-complex',
    //     'Weapon Free Funds': 'military-weapons',
    //     'Tobacco Free Funds': 'tobacco'
    //   }[config.app.title]
    // }
    return activeIssue;
  };

  this.configTargetDateSeries = function () {
    return _config2.default.targetDateSeries.find(function (series) {
      return series.strategy_name_query === _this3.state.strategyName;
    });
  };
}, _temp)) || _class);
exports.default = TargetDateSeries;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TargetDateSeries/TargetDateSeries.js
// module id = 1501
// module chunks = 0